module.exports = __webpack_public_path__ + "static/media/thumbnail.44816e79.jpg";